/* eslint-disable prettier/prettier */
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { MyThunkDispatch, RootState } from 'store';

import { flightsExchangeRequest, flightsFilterClear } from 'action-creators/flights';
import { accountFailure, accountRequest } from 'action-creators/user';
import { flightExchangeResults, searchExchangeFlights } from 'actions/flights';
import { updateAccount } from 'actions/user';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import FlightsExchangeList from 'components/FlightsExchangeList';
import useIsMobile from 'hooks/useIsMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import useUserAccount from 'hooks/useUserAccount';
//import { FlightResultRequestOrderCriteriaEnum } from 'models/flightSearch';
import { fetchAccount } from 'services/userService';
import { extractErrorMessage } from 'utils/generic';

interface Props {
  show: boolean;
  onClose: () => void;
  onBack: () => void;
}
const FlightsExchangeListContainer = ({ show, onClose, onBack }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch<MyThunkDispatch>();
  const {
    changeFlight,
    changeFlightSearch: search,
    changeFlightStatus,
  } = useSelector((state: RootState) => state.flights);
  const { departureCode, arrivalCode, departureDate, arrivalDate, changeDeparture, changeArrival, originalFlight } =
    changeFlight;
  const { isLoadingResults, error, isLoadingSearch, orderCriteria } = changeFlightStatus;
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingResults, setLoadingResults] = useState(false);
  const { t } = useStoreTranslation();
  const toast = useToast();
  const isMobile = useIsMobile();
  const user = useUserAccount();

  const handleFlightSearch = useCallback(async () => {
    if (departureCode && arrivalCode && departureDate && originalFlight?.id) {
      dispatch(accountRequest());
      const {
        data: { data },
      } = await fetchAccount();

      if (data.sessionToken === '' || data.sessionToken === undefined || data.sessionToken === null || data.isOperator) {
        dispatch(accountFailure('sessionToken is empty'));
        history.replace('/login');
      }

      // TODO - Debe ser por algun metodo o de una manera mas eficiente
      data.companyId = user.companyId;
      data.companyName = user.companyName;
      // TODO - Debe ser por algun metodo o de una manera mas eficiente Fin
      
      updateAccount(dispatch, data);
      const payload = {
        departureCode,
        departureDate,
        arrivalCode,
        arrivalDate,
        changeDeparture,
        changeArrival,
        originalFlight,
      };
      dispatch(flightsFilterClear());
      dispatch(flightsExchangeRequest(payload));
      return await dispatch(searchExchangeFlights(payload));
    }
  }, [
    departureCode,
    arrivalCode,
    departureDate,
    originalFlight,
    dispatch,
    arrivalDate,
    changeDeparture,
    changeArrival,
    history,
  ]);

  const handleFlightResult = useCallback(
    async () => dispatch(flightExchangeResults(orderCriteria)),
    [dispatch, orderCriteria],
  );

  useEffect(() => {
    const handleSearch = async () => {
      if (error) {
        return;
      }

      if (
        (search?.results === null || search?.results === undefined || search?.results.length === 0) &&
        !isLoadingResults &&
        !loadingSearch &&
        !isLoadingSearch &&
        !loadingResults
      ) {
        try {
          setLoadingSearch(true);
          const res: any = await handleFlightSearch();
          if (res.resultsCount === 0 && isMobile) {
            history.replace('/travelRequested/exchange-empty', { showNoResults: true });
            return;
          }

          if (res.resultsCount > 0) {
            //Amplitude
            /* const event: ViewTravelResultsScreenEvent = {
              SOURCE: 'TRAVEL_HOME',
              RESULTS: res?.resultsCount ?? 0,
              TRAVEL_PRODUCT_TYPE: 'FLIGHTS',
              TRAVEL_FROM: departurePoint?.code ?? '',
              TRAVEL_TO: arrivalPoint?.code ?? '',
              TRAVEL_DESTINATION_TYPE: '',
              TRAVEL_TRIP_TYPE: '',
              TRAVEL_ADVANCED_PURCHASE: daysCount(new Date(), departureDate).toString(),
              TRAVEL_DATE_FROM: departureDate?.toString() ?? '',
              TRAVEL_DATE_TO: returnDate?.toString() ?? '',
              TRAVEL_TRIP_LENGTH: (daysCount(departureDate, returnDate) + 1).toString(),
              TRAVEL_PASSENGERS: '1',
              TRAVEL_ADULTS: '1',
              TRAVEL_CHILDREN: '0',
              TRAVEL_INFANTS: '0',
              TRAVEL_CLASS_OF_SERVICE: '',
              TRAVEL_ROOMS: '1',
              TRAVEL_WITH_BAGGAGE: '',
              TRAVEL_BRANCH_CODE: process.env.REACT_APP_RAPPI_BRANCH_CODE ?? '',
              SEARCHID: search?.searchId ?? '',
            };

            amplitudelogEvent(amplitudeEvents.VIEW_TRAVEL_RESULTS_SCREEN, event, user);
 */
            setLoadingResults(true);
            await handleFlightResult();
          }
        } catch (error) {
          const message = extractErrorMessage(error);
          toast.add({ type: 'danger', message: message || t('defaultError.default') });
        } finally {
          setLoadingSearch(false);
          setLoadingResults(false);
        }
      }
    };

    if (departureCode && arrivalCode && departureDate) {
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const content = () => (
    <FlightsExchangeList
      isLoading={loadingSearch}
      isLoadingResults={isLoadingResults}
      departureCode={departureCode}
      arrivalCode={arrivalCode}
      departureDate={departureDate}
      arrivalDate={arrivalDate}
      changeDeparture={changeDeparture}
      changeArrival={changeArrival}
      originalFlight={originalFlight}
      flightsResult={search?.results || []}
      onRequest={handleFlightResult}
      onBack={onBack}
      error={error}
    />
  );

  return (
    <>
      <ApplicationOverlayContent sidebar show={show} onClose={onClose} backgroundColor="#f9f9f9">
        {content()}
      </ApplicationOverlayContent>
    </>
  );
};

export default FlightsExchangeListContainer;
